<ng-container *ngIf="enterpriseWorkflowSetupHasRun">
  <div><label class="filter-title">{{title}}</label></div>
  <fieldset [attr.aria-label]="title">
    <div>
      <mat-checkbox
        tabindex="0"
        class="result-filter-cb"
        [checked]="osTypeIsSelected(nonEnterpriseKeyword)"
        (change)="onOsTypeChange(nonEnterpriseKeyword)"
        (keyup.enter)="onOsTypeChange(nonEnterpriseKeyword)">
        <span class="filter-label">{{nonEnterpriseLabel}}</span>
      </mat-checkbox>
    </div>
    <div>
      <mat-checkbox
        tabindex="0"
        class="result-filter-cb"
        [checked]="osTypeIsSelected(enterpriseKeyword)"
        (change)="onOsTypeChange(enterpriseKeyword)"
        (keyup.enter)="onOsTypeChange(enterpriseKeyword)">
        <span class="filter-label">{{enterpriseLabel}}</span>
      </mat-checkbox>
    </div>
  </fieldset>
</ng-container>

